import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from 'store/store';
import { undo, redo } from 'store/reducers/editorSlice';
import { ButtonSize, ButtonTypes } from 'utils/interface.utils';
import { Colors } from 'utils/theme.utils';
import { FontFamily } from 'utils/fonts.utils';
import Assets from 'imports/assets.import';
import { STRINGS } from 'constants/strings.constant';
import PrimaryButton from 'common_components/ui/primary_button/primary_button.ui';
import './undo_redo_buttons.component.scss';

const ICON_SIZE = { width: '16px', height: '16px' };

const UndoRedoButtons = () => {
    const dispatch = useDispatch<AppDispatch>();
    const historyLength = useSelector((state: RootState) => state.editor.history?.length ?? 0);
    const futureLength = useSelector((state: RootState) => state.editor.future?.length ?? 0);

    const canUndo = historyLength > 0;
    const canRedo = futureLength > 0;

    const handleUndo = () => {
        if (canUndo) dispatch(undo());
    };

    const handleRedo = () => {
        if (canRedo) dispatch(redo());
    };

    return (
        <div className="undo_redo_buttons">
            <PrimaryButton
                left_icon={Assets.undo}
                iconSize={ICON_SIZE}
                text={STRINGS.editor.undo}
                fontFamily={FontFamily.medium}
                type={ButtonTypes.OUTLINED}
                size={ButtonSize.MEDIUM}
                style={{ border: `1px solid ${Colors.muted}`, borderRadius: '999px', color: Colors.cream }}
                disabled={!canUndo}
                onClick={handleUndo}
                className="undo_redo_buttons_item"
            />
            <PrimaryButton
                left_icon={Assets.redo}
                iconSize={ICON_SIZE}
                text={STRINGS.editor.redo}
                fontFamily={FontFamily.medium}
                type={ButtonTypes.OUTLINED}
                size={ButtonSize.MEDIUM}
                style={{ border: `1px solid ${Colors.muted}`, borderRadius: '999px', color: Colors.cream }}
                disabled={!canRedo}
                onClick={handleRedo}
                className="undo_redo_buttons_item"
            />
        </div>
    );
};

export default UndoRedoButtons;
